import {
  inventoryManagementServiceStores,
  inventoryManagementHostServiceStores,
} from "@intrasync/inventory-management";
import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Inventory Management Module Service Stores
 *
 * Sourced from `@intrasync/inventory-management`:
 *  - `inventoryManagementServiceStores` — the module's own domain services
 *    (raw-materials, stock-levels, lots, boms, work-orders, transfers, …)
 *  - `inventoryManagementHostServiceStores` — "host-owned" external services
 *    the library expects the host to stand up (users, vendors, warehouses,
 *    projects, customers, shipping-carriers).
 *
 * ServiceStore registration is first-wins/idempotent (see
 * StoreRegistry.registerServiceStore), so names another module already
 * registers with richer config are filtered out here to avoid shadowing them.
 * Collision check at wiring time (grep over src/serviceStores) found exactly
 * these four already registered; everything else the package declares is new.
 */
const STORES_OWNED_BY_OTHER_MODULES = new Set<string>([
  "products", // manufacturing.stores.ts / estimating (serviceView + summary cards)
  "users", // user.stores.ts
  "vendors", // financial.stores.ts
  "customers", // crm.stores.ts
]);

export const inventoryManagementStores: ServiceStoreConfig[] = [
  ...(inventoryManagementServiceStores as unknown as ServiceStoreConfig[]),
  ...(inventoryManagementHostServiceStores as unknown as ServiceStoreConfig[]),
].filter((store) => !STORES_OWNED_BY_OTHER_MODULES.has(store.name));
